/**
 * buildGeohashQuery — shared helper for building a Firestore geohash band query.
 * Mirror of apps/mobile/src/redux/features/firestore/helpers/buildGeohashQuery.ts
 */

import {
    collection,
    Firestore,
    limit,
    orderBy,
    query,
    Query,
    startAt,
    endAt,
} from 'firebase/firestore';

export const GEOHASH_QUERY_LIMIT = 500;

/** Use this for tile queries — no limit to ensure newly painted tiles are visible. */
export const TILES_QUERY_NO_LIMIT = Infinity;

export function buildGeohashQuery(
    firestore: Firestore,
    collectionName: string,
    band: [string, string],
    queryLimit: number = GEOHASH_QUERY_LIMIT,
): Query {
    const [start, end] = band;
    const constraints = isFinite(queryLimit) && queryLimit > 0
        ? [orderBy('geohash'), startAt(start), endAt(end), limit(queryLimit)]
        : [orderBy('geohash'), startAt(start), endAt(end)];
    return query(collection(firestore, collectionName), ...constraints);
}
